import { Injectable } from "@angular/core";
import { Position } from "../../../models/shared/position";
import { isNotNullOrUndefined } from "../../../shared/utils/utils";
import { DateTime } from "luxon";

@Injectable({
  providedIn: "root",
})
export class CommonUtilsService {
  public normalizeLatLng(position: Position | undefined): Position | undefined {
    if (isNotNullOrUndefined(position?.longitude)) {
      return { longitude: ((((position.longitude + 180) % 360) + 360) % 360) - 180, latitude: position.latitude };
    } else {
      return position;
    }
  }

  public isTimestampFromToday(timestamp: number | undefined): boolean {
    if (!timestamp) return false;

    // We need the start of day in UTC because server is in UTC and it fetches forecast data after midnight
    const startOfTodayÙTC = DateTime.now().setZone("UTC").startOf("day");
    return timestamp >= startOfTodayÙTC.toMillis();
  }
}
